<template>
	<b-card class="w-100 no-border">
		<b-card-body>
			<div class="text-center my-3">
				<img src="../../../assets/img/new_avatar_alfred_transp.png" />
			</div>
			<div class="p-3">
				<b-alert :show="show_alert" :variant="alert_variant">
					<span v-html="processMessage"></span>
				</b-alert>
				<b-form @submit.prevent="onSubmit">
					<b-form-group label-for="username" label="E-Mail ou Celular ">
						<b-form-input
							type="text"
							id="username"
							class="mb-0"
							v-model="email"
							placeholder="Digite seu email ou número do seu celular"
							debounce="500"
							:state="validate_email || validate_celular"
						></b-form-input>
						<b-form-invalid-feedback id="username-feedback">
							Informe um endereço de email válido, ou um número de celular cadastrado no
							sistema.
						</b-form-invalid-feedback>
					</b-form-group>

					<b-form-group label-for="password" label="Senha">
						<b-form-input
							type="password"
							id="password"
							class="mb-0"
							v-model="password"
							placeholder="Digite sua senha"
							:state="validate_password"
							debounce="500"
						></b-form-input>
						<b-form-invalid-feedback id="username-feedback">
							Informe sua senha.
						</b-form-invalid-feedback>
					</b-form-group>

					<div class="mt-3">
						<b-button block variant="primary" type="submit" class="btn-custom">
							<b-spinner small v-if="is_loading" class="text-white"></b-spinner>
							{{ !is_loading ? 'Login' : 'Processando' }}
						</b-button>
					</div>

					<div class="mt-4 mb-0 text-center">
						<b-link href="/password/forget" class="text-dark"
							><span class="font-weight-bold text-primary" style="font-size: 16px">
								É seu PRIMEIRO ACESSO? Clique aqui
							</span>
						</b-link>
					</div>
					<div class="mt-4 mb-0 text-center">
						<b-link href="/password/forget" class="text-dark"
							><span class="font-weight-bold text-primary" style="font-size: 14px">
								Esqueci minha senha
							</span>
						</b-link>
					</div>
				</b-form>
			</div>
		</b-card-body>
	</b-card>
</template>

<script>
	import HomeButton from './Elements/HomeButton'
	import ApiService from '../../../common/api.service'
	import JwtService from '../../../common/jwt.service'
	import jwtService from '../../../common/jwt.service'

	export default {
		name: 'Login',
		components: {
			HomeButton
		},
		data() {
			return {
				show_error: false,
				email: '',
				password: '',
				remember: false,
				show_alert: false,
				alert_variant: null,
				processMessage: null,

				is_loading: false,

				validate_email: null,
				validate_celular: null,
				validate_password: null,

				nextPage: '/app/dashboard',
				schoolSelectionPage: '/escolas'
			}
		},
		mounted: function () {
			if (this.$store.state.auth.logged) {
				this.checkToken(JwtService.getToken())

				// window.location.href = '/app/dashboard';
			}
		},
		watch: {
			email: function (newVal, oldVal) {
				this.validateEmail()
				this.validateCelular()
			},
			password: function (newVal, oldVal) {
				this.validatePassword()
			}
		},
		methods: {
			regexEmail: function (email) {
				const re =
					/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				return re.test(email)
			},
			validateEmail: function () {
				if (this.email) {
					if (this.regexEmail(this.email)) {
						this.validate_email = true
					} else {
						this.validate_email = false
					}
				} else {
					this.validate_email = false
				}
			},

			validateCelular: function () {
				if (!this.validateEmail) {
					this.validate_celular = true
					return
				}
				if (this.email) {
					if (this.email.length == 11) {
						this.validate_celular = true
					} else {
						this.validate_celular = false
					}
				} else {
					this.validate_celular = false
				}
			},
			validatePassword: function () {
				if (this.password) {
					this.validate_password = true
				} else {
					this.validate_password = false
				}
			},
			onSubmit: async function () {
				if (!this.email) {
					this.validate_email = false
				}
				if (!this.password) {
					this.validate_password = false
				}

				if (this.validate_password && !this.is_loading) {
					this.is_loading = true
					ApiService.post('login', {
						email: this.email,
						password: this.password
					})
						.then((response) => {
							if (response.data.status == 'success') {
								this.show_alert = true
								this.alert_variant = 'success'
								this.processMessage = response.data.message
								this.$store.dispatch('login', response)

								if (this.$cookies.isKey('alfred_navigation_page')) {
									this.nextPage = this.$cookies.get('alfred_navigation_page').page
								}
								if (
									response.data?.roles[0].name === 'coordenador' ||
									response.data?.roles[0].name === 'professor'
								) {
									jwtService.setEscolasUser(response.data?.escolas)
									window.location.href = this.schoolSelectionPage
								} else {
									window.location.href = this.nextPage
								}
							} else {
								this.show_alert = true
								this.alert_variant = 'danger'
								this.processMessage = response.data.message
							}
						})
						.finally(() => {
							this.is_loading = false
						})
						.catch((error) => {
							this.show_error = true
						})
				}
			},
			checkToken: function (token) {
				this.is_loading = true

				ApiService.get('checkToken', {
					token: token
				})
					.then((response) => {
						//
						if (response.data.status == 'success') {
							// alert('success');
							if (this.$cookies.isKey('alfred_navigation_page')) {
								window.location.href = this.$cookies.get('alfred_navigation_page').page
							} else {
								window.location.href = '/app/dashboard'
							}
						} else {
							// alert('error');
							this.$store.dispatch('logoutInvalidToken')
							/**
							 * * NÃO REDIRECIONAR
							 */
						}
					})
					.finally(() => {
						this.is_loading = false
					})
					.catch((error) => {
						this.show_error = true
					})
			}
		},
		destroyed: function () {}
	}
</script>
<style lang="scss" scoped>
	@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700|Rubik:300,400,500');
	@import './assets/css/pe-icon-7-stroke.css';
	@import './assets/css/materialdesignicons.min.css';
	@import './assets/css/style.css';
	@import './assets/css/colors/red.css';
	.no-border {
		border: none !important;
	}
</style>
